<template>
    <BasePage :loading="loading" :error="error" :params="params">
        <SotHeader v-if="params && !params.hide_header" :params="params" />
        <div ref="pageMainDiv" class="column q-gutter-y-sm no-wrap base-page-content" @scroll="onScroll" style="padding: 40px 20px 0 20px">
            <div v-for="(task, i) in tasks" :key="i">
                <ButtonTask
                    :params="{ task_id: task.id, text_bold: task.text_bold, parent_params: params }"
                    :course-id="+courseId"
                    :disable-start="!tasksEnabled"
                    :allow-exec="task.allowExec"
                    @startTask="onStartTask"
                    :cached-task="task"
                    :module="module"
                    :task-index="i"
                />
            </div>
        </div>
    </BasePage>
</template>

<script>
import BasePage from 'pages/BasePage';
import ButtonTask from 'components/ui/extensions/ButtonTask';
import SotHeader from 'components/ui/design/SotHeader';
import pageScrollSaver from 'src/mixins/pageScrollSaverMixin';

export default {
    name: 'PageTasks',
    components: { SotHeader, ButtonTask, BasePage },
    mixins: [pageScrollSaver],
    props: {
        params: {
            type: Object,
            default: undefined,
        },
        module: {
            type: Object,
            default: undefined,
        },
    },
    mounted () {
        this.$nextTick(() => {
            this.init();
        });
    },
    data () {
        return {
            loading: false,
            error: undefined,
            tasks: undefined,
            moduleId: undefined,
            courseId: undefined,
            tasksEnabled: true,
            completedTasks: [],
        };
    },
    methods: {
        init () {
            this.loading = true;
            this.courseId = this.params.course_id || 1;
            this.tasksEnabled = this.params.tasksEnabled;
            this.moduleId = this.params.module_id;
            this.$db.users.getBoughtCourseInfo(this.courseId).then((r) => {
                if (r) {
                    let filterModule = '';
                    if (this.moduleId) {
                        filterModule = ` and module_id = '${this.moduleId}'`;
                    }
                    this.$db.tasks.getTasks(`course_id = ${this.courseId} ${filterModule} and ((tariff <= ${r.tariff} and tariff >= 0) or tariff = ${+r.tariff * -1})`).then((tasks) => {
                        this.loadTasks(tasks);
                    });
                } else {
                    const filter = `course_id = ${this.courseId}`;
                    /*
                    if (this.moduleId) {
                        filter = `course_id = ${this.courseId} and module_id = ${this.moduleId}`;
                    }
                    */
                    this.$db.tasks.getTasks(filter).then((tasks) => {
                        this.loadTasks(tasks);
                    });
                }
            });
        },
        async loadTasks (tasks) {
            if (this.params.show_all_tasks) {
                this.tasks = tasks.reverse();
                this.loading = false;
                return;
            }

            const { user } = this.$store.state.pages;
            this.completedTasks = [];
            if (user) {
                await this.$db.tasks.getTaskCompletedAll(user.chat_id, this.courseId).then((r) => {
                    this.completedTasks = r;
                });
            }
            // console.log('this.completedTasks:', this.completedTasks);
            let prevModuleTask;
            const [firstTask] = tasks;
            if (firstTask) {
                await this.$db.tasks.getPrevTask(firstTask.course_id, firstTask.scheduled_date).then((r) => {
                    [prevModuleTask] = r;
                });
            }

            // const complTasks = this.completedTasks.filter((i) => i.is_skipped !== '1');

            const result = [];
            const { completedTasks } = this;
            for (let i = 0; i < tasks.length; i += 1) {
                const task = tasks[i];
                task.allowExec = false;

                if (!prevModuleTask && i === 0) {
                    task.allowExec = true;
                }
                let prevTaskCompleted;
                if (prevModuleTask) {
                    // eslint-disable-next-line no-loop-func
                    [prevTaskCompleted] = completedTasks.filter((t) => t.task_id === prevModuleTask.id);
                }
                if (prevTaskCompleted && i === 0) {
                    task.allowExec = true;
                }
                const [currentTaskCompleted] = completedTasks.filter((t) => t.task_id === task.id);
                if (currentTaskCompleted) {
                    task.allowExec = true;
                }

                if (i > 0) {
                    const prevTask = tasks[i - 1];
                    [prevTaskCompleted] = completedTasks.filter((t) => +t.task_id === +prevTask.id);
                    if (prevTaskCompleted) {
                        task.allowExec = true;
                    }
                }
                result.push(task);
            }
            this.loading = false;

            /*
            const result = [];
            let allowNextExecute = false;
            for (let i = 0; i < tasks.length; i += 1) {
                const task = tasks[i];
                task.allowExec = allowNextExecute;
                allowNextExecute = false;

                let prevTaskCompleted;
                if (prevTask) {
                    // eslint-disable-next-line no-loop-func
                    [prevTaskCompleted] = this.completedTasks.filter((t) => t.task_id === prevTask.id);
                }
                if (prevTaskCompleted && i === 0) {
                    task.allowExec = true;
                }

                if (complTasks.length === 0 && i === 0 && !prevTask) {
                    task.allowExec = true;
                }
                if (!task.description) {
                    task.allowExec = true;
                }
                const f = complTasks.filter((t) => t.task_id === task.id)[0];
                if (f) {
                    task.allowExec = true;
                    allowNextExecute = true;
                }

                if (this.moduleId && +task.module_id !== +this.moduleId) {
                    // eslint-disable-next-line no-continue
                    continue;
                }
                result.push(task);
            }
            */
            this.tasks = result;
        },
        onStartTask (e) {
            this.$emit('startTask', e);
        },
    },
};
</script>

<style scoped>

</style>
